import React, { useState } from 'react';
import NewUser from './components/NewUser';
import EditUser from './components/EditUser';
import UsersList from './components/UsersList';
import { Col, Container, Row } from 'react-bootstrap';

const Users = () => {
  const [editUserId, setEditUserId] = useState();
  const setEditUserIdHandler = (user_id) => setEditUserId(user_id);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Users Management</h3>
          <h3 className="page-subhead subhead">Manage workspace users</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <UsersList setEditUserIdHandler={setEditUserIdHandler}/>
        </Col>
        <Col md={4}>
          {!editUserId && <NewUser />}
          {editUserId && <EditUser user_id={editUserId} setEditUserIdHandler={setEditUserIdHandler}/>}
        </Col>
      </Row>
    </Container>
  );
};

export default Users;